import {
  MARK_BUYER_FOR_UNSUBSCRIBE,
  UNMARK_BUYER_FOR_UNSUBSCRIBE
} from 'src/actions/actionTypes'
import { flashNotification } from 'src/actions/notification'
import { SUBSCRIPTIONS } from 'src/constants/messages'

export const markBuyerForUnsubscribe = () => ({
  type: MARK_BUYER_FOR_UNSUBSCRIBE
})

export const unmarkBuyerForUnsubscribe = intl => dispatch => {
  dispatch({ type: UNMARK_BUYER_FOR_UNSUBSCRIBE })
  dispatch(
    flashNotification(
      intl.formatMessage(SUBSCRIPTIONS.notificationUnsubscribed)
    )
  )
}
